import SkipButton from "./skip-button";
import SpeedButton from "./speed-button";
import VolumeControl from "./volume-control";
import PlayPauseButton from "./play-pause-button";

export const ControlsBar: React.FC = () => {
  return (
    <div className="flex items-center justify-between">
      <div className="flex items-center gap-2">
        <SkipButton direction="forward" />
        <PlayPauseButton />
        <SkipButton direction="backward" />
      </div>

      <div className="flex items-center gap-3">
        <SpeedButton />
        <VolumeControl />
      </div>
    </div>
  );
};

export default ControlsBar;
